import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private readonly SESSION_SUBSCRIPTION_SOURCE_KEY = 'subscriptionSource';

  public setSubscriptionSource(source: string): void {
    sessionStorage.setItem(this.SESSION_SUBSCRIPTION_SOURCE_KEY, source);
  }

  public getSubscriptionSource(): string {
    return sessionStorage.getItem(this.SESSION_SUBSCRIPTION_SOURCE_KEY);
  }

  public deleteSubscriptionSource(): void {
    sessionStorage.removeItem(this.SESSION_SUBSCRIPTION_SOURCE_KEY);
  }
}
